module.exports = __webpack_public_path__ + "static/media/x49-logo.44a803fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/X49/x49-logo.svg
// module id = 321
// module chunks = 0